var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',[_c('h4',{staticClass:"text-graph"},[_vm._v("Temperatura "+_vm._s(_vm.title))]),(_vm.loaded)?_c('LineChart',{ref:"Loo",staticClass:"Line",attrs:{"chartdata":_vm.chartdata,"options":_vm.options}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }